export default "__VITE_ASSET__Cvgg5Mcd__"